import { prodapiAxiosClient } from "./prodApiClient";


const getCameraSimpleCountByModelFromPo = (poNumber) => {
    return prodapiAxiosClient
    .get(`/api/v1/productionStatus/poProductionCountSimple/${poNumber}`);
}

const getCameraAdvancedCountByModelFromPo = (poNumber) => {
    return prodapiAxiosClient
    .get(`/api/v1/productionStatus/poProductionCountAdvanced/${poNumber}`);
}


const productionStatusApi = { getCameraSimpleCountByModelFromPo, getCameraAdvancedCountByModelFromPo }
export default productionStatusApi;